import { useEffect, Dispatch, SetStateAction } from "react";

const useAuthChecker = (
  setUsername: Dispatch<SetStateAction<string>>,
  setAuthenticated: SetBoolean,
  setIsLoaded: SetBoolean,
  setIsQuizCompleted: SetBoolean,
) => {
  useEffect(() => {
    const checkSession = async () => {
      const response = await fetch("https://yda-wedding.com/api/session", {
        method: "GET",
        credentials: "include",
      });
      if (response.ok) {
        const data = await response.json();
        setUsername(data["username"]);
        setIsQuizCompleted(data["is_quiz_completed"]);
        setAuthenticated(true);
      } else {
        setAuthenticated(false);
      }
      setIsLoaded(true);
    };

    checkSession();
  }, []);
};

export default useAuthChecker;
